import { render, staticRenderFns } from "./PrimeCompletePopup.vue?vue&type=template&id=4e4c643f&scoped=true"
import script from "./PrimeCompletePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrimeCompletePopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrimeCompletePopup.vue?vue&type=style&index=0&id=4e4c643f&prod&lang=scss&scoped=true"
import style1 from "./PrimeCompletePopup.vue?vue&type=style&index=1&id=4e4c643f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c643f",
  null
  
)

export default component.exports